// extracted by mini-css-extract-plugin
export default {"NotFoundContainer":"NotFound_NotFoundContainer__KsTCA","Illustration":"NotFound_Illustration__PLprd"};